// file src/constants/QUESTION_TYPE.constants.ts
export const questionTypeConstants = {
    GETALL_REQUEST: 'QUESTION_TYPES_GETALL_REQUEST',
    GETALL_SUCCESS: 'QUESTION_TYPES_GETALL_SUCCESS',
    GETALL_FAILURE: 'QUESTION_TYPES_GETALL_FAILURE',
  
    DELETE_REQUEST: 'QUESTION_TYPE_DELETE_REQUEST',
    DELETE_SUCCESS: 'QUESTION_TYPE_DELETE_SUCCESS',
    DELETE_FAILURE: 'QUESTION_TYPE_DELETE_FAILURE',

    CREATE_REQUEST: 'QUESTION_TYPE_CREATE_REQUEST',
    CREATE_SUCCESS: 'QUESTION_TYPE_CREATE_SUCCESS',
    CREATE_FAILURE: 'QUESTION_TYPE_CREATE_FAILURE',

    UPDATE_REQUEST: 'QUESTION_TYPE_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'QUESTION_TYPE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'QUESTION_TYPE_UPDATE_FAILURE',
};